<div *ngIf="isLoading == false">
  <div class="row">
    <div class="col text-center" *ngIf="invitations.length > 0">
      <div class="alert alert-success" role="alert">
        Invitations to join group(s)
      </div>
    </div>
  </div>
  <div *ngFor="let invitation of invitations; let index = index">
    <div
      class="row form-group newSelect mx-0"
      *ngIf="invitation['resolved'] == false"
    >
      <div class="col form-group text-center text-dark">
        <div class="m-2">
          {{ invitation.memberName }}, you're invited to join
        </div>
        <div>
          <span class="text-dark py-1 px-2">
            Group: {{ invitation.groupName }}
          </span>
        </div>
        <div
          *ngIf="
            invitation.description != null &&
            invitation.description.trim() != ''
          "
        >
          <small>{{ invitation.description }} </small>
        </div>
        <div
          *ngIf="invitation.mission != null && invitation.mission.trim() != ''"
        >
          <small>{{ invitation.mission }} </small>
        </div>
        <div>
          <img
            *ngIf="
              invitation.presignedUrl != '' && invitation.presignedUrl != null
            "
            [src]="invitation.presignedUrl"
            class="img-fluid fitimage m-2"
            style="max-width: 150px"
          />
        </div>
        <div class="mt-3">
          <button
            class="btn btn-primary btn-small m-1"
            (click)="Accept(invitation)"
            type="button"
          >
            <span> Accept</span>
          </button>
          <button
            class="btn btn-secondary btn-small m-1"
            (click)="Suppress(invitation)"
            type="button"
          >
            <span>Later</span>
          </button>
          <button
            class="btn btn-danger btn-small m-1"
            (click)="Reject(invitation)"
            type="button"
          >
            <span> Reject</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
